var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarPluginsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.467 1.62c.054-.429-.182-.842-.579-1.014-.397-.173-.86-.063-1.137.27l-10.5 12.6c-.242.29-.294.695-.134 1.037.16.343.505.562.883.562h8.345l-.913 7.304c-.053.43.183.843.58 1.015.397.173.86.063 1.137-.27l10.5-12.6c.242-.29.294-.695.134-1.038-.16-.342-.505-.561-.883-.561h-8.346l.913-7.304z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarPluginsActive);
export default __webpack_public_path__ + "static/media/navbar-plugins-active.229be5c70915927128acaf21bdd7e110.svg";
export { ForwardRef as ReactComponent };